import { render, staticRenderFns } from "./socios-table.vue?vue&type=template&id=3c78d3ff&scoped=true"
import script from "./socios-table.vue?vue&type=script&lang=js"
export * from "./socios-table.vue?vue&type=script&lang=js"
import style0 from "./socios-table.vue?vue&type=style&index=0&id=3c78d3ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c78d3ff",
  null
  
)

export default component.exports